import React from 'react';
import { PropTypes } from 'prop-types';
import { Card, CardContent, Typography } from '@mui/material';
import Chart from 'react-apexcharts';

// Customer-health heatmap: rows = clients, columns = metrics. Color is driven
// by a per-column normalized value (0-100) so metrics on different scales stay
// comparable; the raw value is shown in the tooltip.
// `series` = [{ name: clientName, data: [{ x: metricLabel, y: normalized, raw }] }].
export function UsageHeatmap({ title, subtitle, series, height }) {
  return (
    <Card style={{ marginBottom: 16 }}>
      <CardContent>
        <Typography component='h2' variant='h6' color='primary'>{title}</Typography>
        {subtitle && (
          <Typography variant='body2' color='textSecondary' style={{ marginBottom: 4 }}>{subtitle}</Typography>
        )}
        <Chart
          type='heatmap'
          height={height || Math.max(series.length * 34 + 120, 240)}
          options={{
            chart: { toolbar: { show: false }, animations: { enabled: false } },
            dataLabels: { enabled: false },
            colors: ['#148F77'],
            xaxis: { position: 'top' },
            plotOptions: {
              heatmap: {
                radius: 2,
                enableShades: true,
                shadeIntensity: 0.6,
                colorScale: { ranges: [{ from: 0, to: 0, color: '#EFEFEF', name: 'none' }] },
              },
            },
            tooltip: {
              custom: ({ seriesIndex, dataPointIndex, w }) => {
                const cell = w.config.series[seriesIndex].data[dataPointIndex];
                const row = w.config.series[seriesIndex].name;
                return (
                  '<div style="padding:6px 10px">' +
                  `<strong>${row}</strong><br/>` +
                  `${cell.x}: ${(cell.raw != null ? cell.raw : cell.y).toLocaleString()}` +
                  '</div>'
                );
              },
            },
          }}
          series={series}
        />
      </CardContent>
    </Card>
  );
}

UsageHeatmap.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.node,
  series: PropTypes.array.isRequired,
  height: PropTypes.number,
};
